<template>
    <div id="index">
        <el-container>
            <el-header id="main-header">
                <el-row>
                    <el-col 
                        :md="{span: 4, offset: 0}"
                        :lg="{span: 4, offset: 0}" 
                        :xl="{span: 4, offset: 0}"
                        class="left" 
                    >
                        <!-- <img class="logo" src="../assets/logo.png" alt=""> -->
                        <h2>券管理系统(月饼)</h2>
                    </el-col>
                    
                    <el-col :span="3" :push="17" class="right">
                        <el-col
                            :md="{span:13,offset: 0}"
                            :lg="{span:13,offset: 0}"
                            :xl="{span:13,offset: 0}"
                        >
                            <!-- <el-badge :is-dot="isDot" class="item">
                                <i class="el-icon-bell" style="font-size:24px" @click="reminders"></i>
                            </el-badge> -->
                        </el-col>
                        <el-col :span="11" class="userCon">
                            <el-dropdown class="user" @command="handleCommand">
                            <span class="el-dropdown-link user" style="">
                                <img v-if="user_info.avatar" class="avatar" :src="user_info.avatar" alt="">
                                <img v-else  class="avatar" src="../assets/avatar.jpg" alt="">
                                <i class="el-icon-arrow-down"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="/setting/basic">
                                    <i class="iconfont icon-account"></i>
                                    个人中心
                                </el-dropdown-item>
                                <el-dropdown-item command="/setting/message">
                                    <i class="iconfont el-icon-chat-line-round"></i>
                                    订单查询
                                </el-dropdown-item>
                                <el-dropdown-item divided command="logout"> 
                                    <i class="iconfont icon-ios-log-out"></i>
                                    退出系统
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        </el-col>
                        
                    </el-col>
                </el-row>
            </el-header>
            <el-container id="main-content">
                <el-aside :width="asideWidth" class="aside">
                    <el-menu 
                        v-if="$router.options.routes.length > 0" 
                        :background-color="'#222D3E'" 
                        :text-color="'#fff'"
                        :default-active="$router.history.current.path"
                        :collapse="collapse"
                        :collapse-transition="false"
                        :unique-opened="true"
                    >
                        <template 
                            v-for="(item, key) in $router.options.routes"
                        > 
                            <template v-if="item.hasOwnProperty('children')">
                                <template v-if="item.hidden == false">
                                    <template v-if="item.children.length > 1">
                                        <el-submenu :index="item.path+key">
                                            <template slot="title">
                                                <i :class="item.iconCls"></i>
                                                <span>{{ item.name}}</span>
                                            </template>
                                            <template v-for="(i, k) in item.children">
                                                <!-- <router-link :to="i.path"> -->
                                                    <template v-if="i.hidden == false">
                                                        <el-menu-item class="children-menu-list" :index="i.path" @click="$router.push(i.path)">
                                                            {{i.name}}
                                                        </el-menu-item>
                                                    </template>
                                                <!-- </router-link> -->
                                            </template>
                                            
                                        </el-submenu>
                                    </template>
                                    <template v-else>
                                        <el-menu-item  :index="item.children[0].path" @click="$router.push(item.children[0].path)">
                                            <i :class="item.children[0].iconCls"></i>
                                            <span slot="title">{{ item.children[0].name}}</span>
                                        </el-menu-item>
                                    </template> 
                                </template> 

                            </template>
                            <template v-else>
                                <template v-if="item.hidden == false">
                                    <el-menu-item  :index="item.path" @click="$router.push(item.path)">
                                        <i :class="item.iconCls"></i>
                                        <span slot="title">{{ item.name}}</span>
                                    </el-menu-item>
                                </template>
                            </template>    
                        </template>
                        <el-menu-item :index="'999'"  @click="handleCollapse" class="retract-menu">
                            <i v-if="collapse" class="el-icon-d-arrow-right"></i>
                            <i v-else class="el-icon-d-arrow-left"></i>
                            <span>收起</span>
                        </el-menu-item>
                    </el-menu>
            



                </el-aside>

                <el-main>
                    <el-breadcrumb separator="/">
                        <!-- <el-breadcrumb-item> {{$router.history.current.name}}</el-breadcrumb-item> -->
                            <el-row>
                                <el-col :span="24">
                                    <el-card shadow="never">
                                        {{$router.history.current.name}}
                                        <span style="float:right" v-on:click="back"> 
                                            <i class="iconfont icon-fanhui" style="text-align:center;cursor:pointer"></i>
                                        </span>
                                    </el-card>
                                </el-col>
                            </el-row>
                    </el-breadcrumb>                    
                    <div style="padding:15px">
                        <router-view></router-view>
                    </div>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>
<script>
import { getCookie } from '../env/util';
import requestMixin from '../mixins/request'
import CommonMixin from '../mixins/common'
export default {
    mixins : [requestMixin, CommonMixin],
    name: "app",
    components: {
    },
    data(){
        return{
            collapse : false,
            asideWidth : '240px',
            isDot:true,
        }
    },
    mounted(){
    },
    watch : {
        collapse ( v ) {
            if( v ){
                this.asideWidth = '60px';
            }else{
                this.asideWidth = '220px';
            }
        }
    },
    methods : {
        handleCommand(v){
            if( v == 'logout'){
                this.logout();
                return;
            }
            if(v) this.$router.push({path: v})
        },
        handleCollapse(){
            this.collapse = !this.collapse;
        },
        back(){
            this.$router.go(-1);//返回上一层
        },
        //提醒信息
        reminders(){
            this.isDot = false;
            this.$router.push({
                path:'/setting/message'
            })
        }
    }
};
</script>
<style lang="less" >
@import url('//at.alicdn.com/t/font_678863_k3iw01kbj9.css');
#index{
    .el-header{
        color: #333;
        line-height: 60px;
        border-bottom:1px solid #f0f0f0;
        .left{
                display: flex;
                text-align: middle;
                align-items: center;

                height: 100%;
            .logo{
                height:50px;
            }
            .company{
                font-size:18px;
                padding:0 10px;
                font-size: 18px;
            }
            
        }
        .item{
            margin-top: 12px;
            margin-right: 10px;
            cursor: pointer;
        }
        .right{
            text-align: right;
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            .user {
                padding-top:4px;
                display: flex;
                text-align: middle;
                align-items: center;
                float: right;
                .avatar{
                    height : 45px;
                    border-radius: 50%;
                    margin-right:10px;
                };
            .el-dropdown-link {
                    cursor: pointer;
                    color: #409EFF;
                }
            }
        }
    }
    .el-aside {
        color: #333;
        background: #222D3E;

        .el-menu{
            border-right:none !important;
            width: 100%;
            height:100%;
            position: relative;

            .children-menu-list{
                padding-left: 51px !important;
            }
            i{
                // padding-left:10px;
                // padding-right:10px;
                margin-right:15px;
                color: white;
            }
            .retract-menu{
                position: absolute;
                bottom:0;
                left:0;
                width: 100%;
            }
            
        }
        
    }
    .el-main {
        .el-breadcrumb{
            margin-bottom:10px;
            font-size:26px;
        }
        // background-color: #F5F7FA;
        background-color: #f7f7f7;
        color: #333;
        // text-align: center;
        // line-height: 160px;
        height: 100%;
        padding:0px;
    }
}
</style>
